import { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";

const obtenerEstadoRol = async (code: string) => {
    const response: Promise<AxiosResponse> = axiosInstance.get(`siscred-api-recaudacion/v1/rol/obtener-rol`,{ params: { code }});
    return response;
};

const bloquearDesbloquearRol = async (body: any) => {
    
    const headers = {
        'X-Hide-Toast': 'true',
        "X-Hide-Loader" : 'true',
    };
    
    try {
        const response: Promise<AxiosResponse> = axiosInstance.post(`siscred-api-recaudacion/v1/rol/blockunlockrol`, body, {headers: headers});
        return response;
    } catch (error) {
        throw error;
    }

};

export {
    obtenerEstadoRol,
    bloquearDesbloquearRol,
};
